import React, { Component } from 'react'
import { Container, Loader } from 'semantic-ui-react'
import ResponsiveContainer from './containers/ResponsiveContainer'
import ContatoComponent from './components/ContatoComponent'
import EmpresaComponent from './components/EmpresaComponent'
import ImagensComponent from './components/ImagensComponent'
import ProdutosComponent from './components/ProdutosComponent'
import FooterComponent from './components/FooterComponent'

class HomepageLayout extends Component {
  state = {
    loading: true,
  }

  componentDidMount() {
    this.setState({ loading: false })
  }

  render() {
    let { loading } = this.state

    return loading ? (
      <Container>
        <Loader active>Aguarde...</Loader>
      </Container>
    ) : (
      <ResponsiveContainer>
        <Container fluid>
          <section id="section-produtos">
            <ProdutosComponent />
          </section>
          <section id="section-imagens">
            <ImagensComponent />
          </section>

          <section id="section-empresa">
            <EmpresaComponent />
          </section>

          <section id="section-contato">
            <ContatoComponent />
          </section>

          <FooterComponent />
        </Container>
      </ResponsiveContainer>
    )
  }
}
export default HomepageLayout
